<div class="root" [class.box-link]="alertData.possuiLink" (click)="handleClick()">
  <div class="content-container">
    <span class="message">{{ alertData.mensagem }}</span>

    <span class="action">{{ alertData.acao }}</span>
  </div>

  <div *ngIf="alertData.possuiLink && icon" class="arrow">
    <app-lucide-icon [iconName]="'chevron-right'"></app-lucide-icon>
  </div>
</div>
